const REASONS = [
    {
        n: "01",
        title: "We listen first.",
        body: "Every plan begins with a real conversation about your property, your family, and what you actually want the next twenty years to look like. Not a checklist of forms."
    },
    {
        n: "02",
        title: "We stay in touch.",
        body: "We aim to return emails and calls promptly and to keep you informed as the work moves. You should not have to wonder where your matter stands."
    },
    {
        n: "03",
        title: "We sweat the small things.",
        body: "Small drafting choices decide big outcomes years later: dates, cross-references, beneficiary names. We take them seriously so the plan you sign today still does the job when it needs to."
    },
    {
        n: "04",
        title: "We charge plainly.",
        body: "Flat fees for most estate and formation work, clear engagement letters, and honest scoping before we start. No surprises on the invoice."
    }
];

export default function WhyChoose() {
    return (
        <section
            data-testid="why-choose-section"
            className="relative py-24 lg:py-32 bg-white border-t border-acre-line"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-4">
                    <div className="flex items-center mb-6">
                        <span className="acre-tick" />
                        <span className="text-[11px] uppercase tracking-[0.28em] text-acre-muted">
                            Our Approach
                        </span>
                    </div>
                    <h2 className="font-serif-display text-4xl lg:text-5xl tracking-tight leading-[1.05] text-acre-secondary">
                        Careful work, honestly priced.
                    </h2>
                    <p className="mt-6 text-acre-muted text-base leading-relaxed">
                        Every engagement is built on the four commitments below. This is the way we believe this work should be done.
                    </p>
                </div>

                <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12">
                    {REASONS.map((r) => (
                        <div key={r.n} data-testid={`reason-${r.n}`} className="border-t border-acre-line pt-6">
                            <div className="font-serif-display text-acre-secondary text-xl">{r.n}</div>
                            <h3 className="font-serif-display text-2xl mt-2 text-acre-ink leading-snug">
                                {r.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-acre-muted">{r.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
